import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import "./style.css";
import HeaderFunctions from "../HeaderFunctions/HeaderFunctions";
import Sidebar from "./../Datamigration/sidebar";

const Loader = () => (
  <div className="spinner-border text-primary" role="status">
    <span className="visually-hidden">Loading...</span>
  </div>
);

const PatientView = () => {
    const location = useLocation();
    //const data = location.state?.ViewData || {};
    // const patientDemographics = data.patient_demographics;
    const Id = location.state?.id || {};
    //const patientDemographics = location.state?.ViewData || {};
    const [patientDemographics, setDemographics] = useState([]);
    const [patientMedications, setMedications] = useState([]);
    const [patientAdministeredimmunizations, setAdministeredimmunizations] = useState([]);
    const [patientFamilyhistory, setFamilyhistory] = useState([]);
    const [patientLabresults, setLabresults] = useState([]);
    //const [patientMedicationrefillrequest, setMedicationrefillrequest] = useState([]);
    const [patientOrders, setOders] = useState([]);
    const [patientAllinsurance, setAllinsurance] = useState([]);
    const [patientAllergies, setAllergies] = useState([]);
    const [patientAppointments, setAppointments] = useState([]);
    const [patientDiagnosis, setDiagnosis] = useState([]);
    const [patientInsurances, setInsurances] = useState([]);
    const [patientMedicalhistory, setMedicalhistory] = useState([]);
    const [patientSocialhistory, setSocialhistory] = useState([]);
    const [patientVitalb, setVitalb] = useState([]);
    const [patientVitalsa, setVitalsa] = useState([]);
    //const [patientDocuments, setDocuments] = useState([]);
    const [patientPrescriptions, setPrescriptions] = useState([]);
    const [surgeryHistory, setSurgeryhistory] = useState([]);

    useEffect(() => {
        const initiaData = async () => {
            try {
                const response = await axios.get(`http://208.109.243.219:5001/patient/${Id}`, null,{
                headers: {
                    Accept: 'application/json',
                }
                });
                setDemographics(response.data.patient_demographics);
                setMedications(response.data.medications);
                setAdministeredimmunizations(response.data.administered_immunizations);
                setFamilyhistory(response.data.family_history);
                setLabresults(response.data.lab_results);
                //setMedicationrefillrequest(response.data.medication_refill_request);
                setOders(response.data.orders);
                setAllinsurance(response.data.patient_all_insurance);
                setAllergies(response.data.patient_allergies);
                setAppointments(response.data.patient_appointments);
                setDiagnosis(response.data.patient_diagnosis);
                setInsurances(response.data.patient_insurances);
                setMedicalhistory(response.data.patient_medical_history);
                setSocialhistory(response.data.patient_social_history);
                setVitalb(response.data.patient_vital_b);
                setVitalsa(response.data.patient_vitals_a);
                //setDocuments(response.data.patientdocuments);
                setPrescriptions(response.data.prescriptions);
                setSurgeryhistory(response.data.surgery_history);
            } catch (error) {
                console.error('Error fetching Patient data for View:', error);
            }
        };
    
        initiaData(Id);
      }, []);

    const formatKey = (key) => {
        return key
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
      };

    const { loading, loadingoverview, loadingig, loadingusermaser, loadingcustomerlist, loadingprojectlist, loadingrolelist, loadingscopelist, handleLogout, handleOverviewClick, handleIGClick, handleUserMaster, handleCustomerList, handleProjectList, handleRoleList, handleScopeList } = HeaderFunctions();

    return (
        <>
        <Header loading={loading} loadingoverview={loadingoverview} loadingig={loadingig} loadingusermaser={loadingusermaser} loadingcustomerlist={loadingcustomerlist} loadingprojectlist={loadingprojectlist} loadingrolelist={loadingrolelist} loadingscopelist={loadingscopelist} handleLogout={handleLogout} handleOverviewClick={handleOverviewClick} handleIGClick={handleIGClick} handleUserMaster={handleUserMaster} handleCustomerList={handleCustomerList} handleProjectList={handleProjectList} handleRoleList={handleRoleList} handleScopeList={handleScopeList} />

        <div className="container">
            <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page"></li>
            </ol>
            </nav>
        </div>
        <div className="container pb-4">
            <div className="box-bdr-dash">
                <div className="row">
                    <Sidebar/>
                    <div className="col-md-10">
                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Patient Detail</span>
                            </div>
                            <div>
                            <span>Name :</span>
                             <span><b>{ patientDemographics.first_name}</b></span> <span><b>{ patientDemographics.last_name}</b></span>  
                            </div>
                        </div>
                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Patient Demographics</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientDemographics).map(([key, value]) => (                                    
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Administered Immunizations</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientAdministeredimmunizations).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Family History</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientFamilyhistory).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Lab Results</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientLabresults).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/*<div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Medication Refill Request</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientMedicationrefillrequest).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div> */}

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">orders</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientOrders).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">All Insurance</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientAllinsurance).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Allergies</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientAllergies).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Appointments</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientAppointments).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Diagnosis</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientDiagnosis).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Insurances</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientInsurances).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Medical history</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientMedicalhistory).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Social history</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientSocialhistory).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Vitals A</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientVitalsa).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Vitals B</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientVitalb).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Documents</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientDocuments).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div> */}

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Prescriptions</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(patientPrescriptions).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                                <span className="pd-overview-count">Surgery History</span>
                            </div>
                            <div className="row box-row">
                                {Object.entries(surgeryHistory).map(([key, value]) => (
                                    <div key={key} className="box">
                                        <span className="pd-overview-count"><b>{formatKey(key)}</b></span>
                                        <span>{value ?? "N/A"}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default PatientView;
